<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout row wrap align-center justify-center>
      <v-flex xs12 md6>
        <material-card
          title="Ubah Token Akses"
          text="silahkan ubah token akses anda disini!"
          elevation-24
        >
          <v-form>
            <v-container>
              <v-layout column>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <strong>
                    <v-text-field :value="user.token_test" disabled label="Token akses saat ini"></v-text-field>
                  </strong>
                  <v-text-field
                    outline
                    v-model="access"
                    :rules="accessRules"
                    prepend-inner-icon="mobile_off"
                    name="access"
                    required
                    label="Token Akses Baru"
                    id="access"
                    counter
                    @keypress.enter="changeAccess"
                  ></v-text-field>
                  <v-btn
                    :loading="loading"
                    depressed
                    fab
                    block
                    color="secondary"
                    :disabled="!valid || loading"
                    @click="changeAccess"
                    class="mx-0 font-weight-light"
                  >
                    Ubah Token Akses
                    <span slot="loader" class="custom-loader">
                      <v-icon light>cached</v-icon>
                    </span>
                  </v-btn>
                </v-form>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: false,
      loader: null,
      valid: false,
      user: {},

      access: "",
      accessRules: [v => !!v || "Token Akses tidak boleh kosong"]
    };
  },

  created() {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("access_token");

    axios
      .get("user")
      .then(res => {
        let data = res.data.data;

        this.user = data;
      })
      .catch(err => {
        console.log(err.response);
      });
  },

  methods: {
    ...mapMutations("app", ["setAuth", "setAlert"]),

    changeAccess() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      if (this.$refs.form.validate()) {
        this.loader = "loading";
        const l = this.loader;
        this[l] = !this[l];

        let formData = {
          token_test: this.access
        };

        axios
          .patch("/token-test", formData)
          .then(response => {
            this.setAlert({
              status: true,
              text: "Token Akses berhasil di ubah",
              type: "success"
            });

            this.$router.push("/dashboard");
          })
          .catch(error => {
            console.log(error.response);

            this.setAlert({
              status: true,
              text: error.response.data.message.token_test[0],
              type: "error"
            });

            this[l] = false;
            this.loader = null;
          });
      }
    }
  }
};
</script>
